import React, { useEffect, useState } from "react";
import { Header } from "../header";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../store/indexStore";
import { BrowseProducts } from "./Tools";
import Iterator from "../utils/Iterator";
import OrderElement from "./OrderElement/OrderElement";
import OrderDetiles from "./OrderElement/OrderDetiles";
import Visibility from "../utils/Visibility";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";
import { Skeleton } from "../ui/skeleton";
import IsNotActive from "../IsNotActive/IsNotActive";
import { OrderModel } from "../../Models/OrderModel";
import { Button } from "../ui/button";

function Orders() {
  const params = useParams();
  const { t } = useTranslation();
  const {
    fetchOrdersAction,
    orders,
    style,
    getStyle,
    showOrderAction,
    restaurant,
    fetchBranchesAction,
    name,
    ordersLoading,
    orderLoading,
    order,
  } = indexStore();
  const tokenOrder = localStorage.getItem("tokenOrder" + params.branch_id);
  const [showAll, setShowAll] = useState(true);
  const location = useLocation();
  useEffect(() => {
    // جلب النمط إذا لم يتم تحميله بعد
    if (Object.keys(style).length === 0) getStyle(params);

    // جلب بيانات الفرع إذا لم يتم تحميلها بعد
    if (Object.keys(restaurant).length === 0)
      fetchBranchesAction({ domain: params.domain });

    // دالة لجلب الطلبات (حسب showAll)
    const fetchOrdersNow = () => {
      if (tokenOrder) {
        fetchOrdersAction({
          phoneCustomer: tokenOrder,
          domain: params.domain,
          all: false,
        });
      }
    };

    // تنفيذ عند تحميل الصفحة أول مرة
    fetchOrdersNow();

    // تكرار التحديث كل 4 دقائق
    const intervalId = setInterval(() => {
      fetchOrdersNow();
    }, 240000); // 4 دقائق = 240000 مللي ثانية

    // معالجة حالة العودة من صفحة الدفع
    const searchParams = new URLSearchParams(location.search);
    const fromCheckout = searchParams.get("confirm_payment");
    if (fromCheckout === "true") {
      localStorage.removeItem(`cart${params.branch_id}`);
      window.dispatchEvent(new Event("cart-updated"));
    }

    // تنظيف عند مغادرة الصفحة
    return () => clearInterval(intervalId);
  }, [tokenOrder, params.domain, params.branch_id, showAll]); // مهم إدراج showAll هنا

  const handleOrderClick = (order: OrderModel) => {
    showOrderAction({ ...order });  
  };
  const handelShowAll = () => {
    setShowAll(!showAll);
    fetchOrdersAction({
      phoneCustomer: tokenOrder,
      domain: params.domain,
      all: true,
    });
  };

  return (
    <IsNotActive>
      <div className="flex flex-col flex-grow bg-background">
        <title>{params?.domain?.toUpperCase()}</title>
        <Header
          backgroundColorfull={true}
          url={`/${params.domain}/${params.branch_id}`}
        />
        <div className=" flex flex-col mb-28 gap-4">
          <div className={`bg-primary rounded-b-3xl p-3 pb-5`}>
            <div className="flex flex-row justify-between items-center">
              <h3 className="text-3xl font-bold bg-primary !text-onPrimary">
                {t("gloabl.orders")}
              </h3>
              <BrowseProducts
                params={params}
                t={t}
                className={"!bg-onPrimary text-primary"}
              />
            </div>
          </div>
          <div className="p-4">
            <Sheet>
              <Visibility visible={!ordersLoading}>
                <Iterator
                  data={orders}
                  render={(e, i) => (
                    <SheetTrigger asChild>
                      <OrderElement
                        name={name}
                        t={t}
                        params={params}
                        order={e}
                        index={i}
                        tokenOrder={tokenOrder}
                        onClick={(order: OrderModel) => handleOrderClick(order)}
                      />
                    </SheetTrigger>
                  )}
                />
              </Visibility>
              <SheetContent
                side={"bottom"}
                className="flex flex-col gap-4 pb-20  bg-background max-h-[60vh] overflow-y-auto z-50 "
              >
                <OrderDetiles
                  order={order}
                  t={t}
                  name={name}
                  loading={orderLoading}
                />
              </SheetContent>
            </Sheet>
          </div>
          <Visibility visible={showAll}>
            <Button onClick={handelShowAll} variant={"link"}>
              {t("gloabl.showAllOrders")}
            </Button>
          </Visibility>
          <Visibility visible={ordersLoading}>
            <Iterator data={[1, 2, 3]} render={(e, i) => <OrdersLoading />} />
          </Visibility>
        </div>
      </div>
    </IsNotActive>
  );
}

export default Orders;
const OrdersLoading = () => (
  <div className="border p-4 rounded-lg shadow-md flex justify-between items-center cursor-pointer hover:shadow-lg">
    <div className="flex flex-col gap-2">
      <Skeleton className={"w-48 h-"} />
      <Skeleton className={"w-48 h-4"} />
      <Skeleton className={"w-48 h-4"} />
      <Skeleton className={"w-48 h-4"} />
    </div>
    <Skeleton className={"w-8 h-8"} />
  </div>
);
